import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { ComunicadosBenef } from '../../../interfaces/entities/ComunicadosBenef';
import { QuestaoPesquisaSatisfacao, RespostasPesquisaSatisfacao } from '../../../interfaces/entities/QuestaoPesquisaSatisfacao';
import { atualizarIndLidoComunica, getComunicadosBenef } from '../../../services/ComunicadoService';
import { getQuestoes, respQuestao } from '../../../services/PesquisaSatisfacaoService';
import { useNotification } from '../../../Store/contexts/NotificationContext';
import { sxButton } from '../sxProps';
import Question from './Question';
import './styles.css';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function PesquisaSatisfacao() {
    const [questions, setQuestions] = useState<QuestaoPesquisaSatisfacao[]>([]);
    const [notification, setNotification] = useState<ComunicadosBenef>();
    const [answers, setAnswers] = useState<RespostasPesquisaSatisfacao | null>(null);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [confirm, setConfirm] = useState<boolean>(false);
    const [answerQuestions, setAnswerQuestions] = useState<boolean>(false);
    const { notificationId, idQuestOperador } = useParams();
    const { updateUnreadNotificationsNumber } = useNotification();
    const navigate = useNavigate();
    const [modalFeedback, setModalFeedback] = useState<null | {
        icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
        closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
    }>(null);
    const { contrastMode } = useAccessibility();

    useEffect(() => {
        getQuestions();
        getNotification();
    }, [idQuestOperador]);

    const getQuestions = async () => {
        setShowLoading(true);
        const result = await getQuestoes(`${idQuestOperador}`);
        if (result !== null) {
            setQuestions(result);
        }
        setShowLoading(false);
    }

    const getNotification = async () => {
        setShowLoading(true)
        const notificationsArray = await getComunicadosBenef(`pesquisa_satisf`);
        if (notificationsArray !== null) {
            const result = notificationsArray.find((element: ComunicadosBenef) => `${element.idComunic}` === notificationId);
            if (result !== undefined) {
                setNotification(result);
            }
            if (result?.indLido === 'N') {
                await atualizarIndLidoComunica(`${notificationId}`, 'S');

                await updateUnreadNotificationsNumber();
            }
        }
        setShowLoading(false);
    }

    useEffect(() => {
        if (questions.length > 0) {
            const defaultAnswers: RespostasPesquisaSatisfacao = {
                idQuestOperador: `${idQuestOperador}`,
                respostas: []
            }
            questions.forEach((question) => {
                defaultAnswers.respostas.push({
                    idQuestao: question.id,
                    resp: '',
                    obs: ''
                })
            });

            setAnswers(defaultAnswers);
        }
    }, [questions]);

    const handleAnswer = (value: string, index: number) => {

        if (answers !== null) {
            let newAnswers = answers;
            newAnswers.respostas[index].resp = value;
            setAnswers(newAnswers);
        }
    }

    const handleConfirmation = async () => {
        setConfirm(false)
    }

    const handleConfirm = async () => {
        if (answers !== null) {
            var validation = true;
            answers.respostas.forEach((answer, index) => {
                if (questions[index].indObrigatorio === 'S' && answer.resp === '') {
                    validation = false;
                }
            })

            if (validation) {
                setShowLoading(true);
                const result = await respQuestao(answers);

                if (result === 'OK') {
                    setShowLoading(false);
                    setModalFeedback({
                        icon: 'success',
                        title: 'Confirmação',
                        subTitle: 'Suas respostas foram enviadas com sucesso! Conhecer sua opinião nos faz melhorar cada dia mais.',
                        textButton: 'Voltar',
                        closeAction: closeModalSuccess,
                        buttonAction: closeModalSuccess,
                        showButtonModal: true
                    });
                }
            }
            else {
                setConfirm(true)
            }
        }
    }

    const closeModalSuccess = () => {
        setModalFeedback(null);
        goBack();
    }

    const goBack = () => {
        navigate(-1);
    }


    return (
        <div className="satisfaction-survey-content">
            <LoadingApp showLoading={showLoading} />
            <div className="satisfaction-survey-header">
                <h1 className='satisfaction-survey-title'>Pesquisa de satisfação</h1>
                <h1 className='satisfaction-survey-description-title'>{notification?.openComunic.abrirPesqSatisfacao.titulo}</h1>
                <Typography className='satisfaction-survey-subtitle'>{notification?.openComunic.abrirPesqSatisfacao.subTitulo}</Typography>
            </div>
            <div className="satisfaction-survey-body">
                <div className="satisfaction-survey-questions">
                    {questions.map((question, index) => {
                        return (
                            <Question
                                question={question}
                                handleAnswer={handleAnswer}
                                confirm={confirm}
                                index={index}
                                handleConfirmation={handleConfirmation}
                                key={question.id} />
                        )
                    })}
                </div>
                <Typography className='satisfaction-survey-subtitle'>
                    <b>Importante:</b>&nbsp;
                    Os comentários não serão respondidos. Caso tenha alguma dúvida ou solicitação, pedimos que entre em contato por um de nossos canais oficiais de atendimento.
                </Typography>
                <div className="satisfaction-survey-button">
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleConfirm}
                        sx={sxButton}
                        disabled={false}
                        fullWidth>
                        Enviar
                    </Button>
                </div>
                <button className="back-button" onClick={goBack}>
                    <FontAwesomeIcon style={{color: contrastMode ? "#fff" : ''}} icon={faChevronLeft} />
                    &nbsp;&nbsp;<u style={{color: contrastMode ? "#fff" : ''}}>Voltar</u>
                </button>
            </div>
            <ModalFeedBack
                showModal={!!modalFeedback}
                icon={modalFeedback?.icon as 'success' | 'error'}
                textButton={modalFeedback?.textButton as string}
                title={modalFeedback?.title as string}
                subTitle={modalFeedback?.subTitle as string}
                showButtonModal={modalFeedback?.showButtonModal}
                handleShowModal={modalFeedback?.closeAction}
                handleButtonModal={modalFeedback?.buttonAction}
            />
        </div>
    )
}

export default PesquisaSatisfacao